import React, { useState } from "react";

export interface PeriodState {
  from: string;
  to: string;
  compareFrom: string;
  compareTo: string;
  compareEnabled: boolean;
}

function isoDaysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export function defaultPeriod(): PeriodState {
  return { from: isoDaysAgo(30), to: isoDaysAgo(0), compareFrom: isoDaysAgo(60), compareTo: isoDaysAgo(31), compareEnabled: false };
}

// Test #29 ("Director puede comparar períodos"): every dashboard endpoint
// accepting from/to also accepts compareFrom/compareTo per the contract.
// This is the one shared control every MVP-E tab wires into its query
// params — no per-tab reimplementation of date pickers.
export default function PeriodControls({ period, onChange, allowCompare = true }: { period: PeriodState; onChange: (p: PeriodState) => void; allowCompare?: boolean }) {
  const [local, setLocal] = useState(period);

  function commit(next: PeriodState) {
    setLocal(next);
    onChange(next);
  }

  return (
    <div className="row period-controls" style={{ gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 14 }}>
      <label className="meta">
        Desde
        <input type="date" value={local.from} onChange={(e: any) => commit({ ...local, from: e.target.value })} />
      </label>
      <label className="meta">
        Hasta
        <input type="date" value={local.to} onChange={(e: any) => commit({ ...local, to: e.target.value })} />
      </label>
      {allowCompare && (
        <>
          <label className="meta">
            <input type="checkbox" checked={local.compareEnabled} onChange={(e: any) => commit({ ...local, compareEnabled: e.target.checked })} /> Comparar
            período
          </label>
          {local.compareEnabled && (
            <>
              <label className="meta">
                Comparar desde
                <input type="date" value={local.compareFrom} onChange={(e: any) => commit({ ...local, compareFrom: e.target.value })} />
              </label>
              <label className="meta">
                Comparar hasta
                <input type="date" value={local.compareTo} onChange={(e: any) => commit({ ...local, compareTo: e.target.value })} />
              </label>
            </>
          )}
        </>
      )}
    </div>
  );
}

export function periodQuery(p: PeriodState): Record<string, string | undefined> {
  return {
    from: p.from,
    to: p.to,
    compareFrom: p.compareEnabled ? p.compareFrom : undefined,
    compareTo: p.compareEnabled ? p.compareTo : undefined,
  };
}
